export default {
    "lang": "日语",
    application: {
        name: '情報発布システム',
    },
    ajaxTip: {
        success: '成功',
        error: '失敗',
        noAccess: 'このリソースへのアクセス権がありません',
        notFound: 'アクセスしたリソースが存在しません',
        serverBusy: 'サーバーが混雑しています',
        timeOut: 'タイムアウト',
    },
    menu: {
        home: 'ホーム',
        template: 'テンプレート管理',
        program: '番組かんり',
        playplan: '再生計画',
        device: 'デバイス管理',
        "source-material": 'マテリアル管理',
        material: '素材',
        checkManage: '審査管理',
        setting: '設定',
        usercenter: "ユーザーセンター",
        adminManage: "デバイス管理",
        schedule: "未了事项",
        capitalassets: "資産管理",
        modifyPassword: "パスワードの変更",
        logout: "ログアウト",
        "add": "追加",
        "edit": "編集",
        "delete": "削除",
        "view": "参照",
        "menu_1": "ホーム",
        "menu_2": "デバイス管理",
        "menu_3": "編集(詳細設定-標準編集-ネットワーク変更)",
        "menu_4": "即時コマンド",
        "menu_5": "編集(部署移管)",
        "menu_6": "戦略",
        "menu_7": "ボリューム設定",
        "menu_8": "明るさ設定",
        "menu_9": "ダウンロード設定",
        "menu_10": "スリープ設定",
        "menu_11": "デバイスプロパティ",
        "menu_12": "編集/追加",
        "menu_13": "番組かんり",
        "menu_14": "公開履歴",
        "menu_15": "削除（一括/単体）",
        "menu_16": "公開中のプログラム",
        "menu_17": "グループ分け",
        "menu_19": "プログラムリスト",
        "menu_20": "コンテンツ編集",
        "menu_21": "プログラムコピー",
        "menu_23": "プログラム公開",
        "menu_24": "マテリアル管理",
        "menu_25": "アップロード",
        "menu_28": "クイック公開",
        "menu_29": "テンプレート管理",
        "menu_30": "パブリックテンプレート",
        "menu_31": "すぐに使う",
        "menu_32": "マイテンプレート",
        "menu_33": "パブリックテンプレートに公開",
        "menu_35": "共有履歴",
        "menu_36": "審査管理",
        "menu_37": "プログラム審査",
        "menu_38": "審査（承認/却下）",
        "menu_39": "マテリアル審査",
        "menu_41": "審査履歴（オペレーター）",
        "menu_42": "審査履歴（審査員）",
        "menu_43": "承認数確認",
        "menu_44": "組織管理",
        "menu_45": "ログ管理",
        "menu_46": "再生ログ",
        "menu_47": "公開ログ",
        "menu_48": "エラーログ",
        "menu_49": "操作ログ",
        "menu_50": "ファイルログ",
        "menu_51": "ログインログ",
        "menu_52": "コンテンツ承認",
        "menu_53": "ストレージスペース",
        "menu_54": "組織構造",
        "menu_55": "ロール権限",
        "menu_56": "認可",
        "menu_57": "参照(認可権限)",
        "menu_58": "組織メンバー",
        "menu_60": "配下ユーザーのパスワードリセット",
        "menu_61": "資産管理",
        "menu_62": "マイ残高",
        "menu_63": "参照(資金明細)",
        "menu_64": "マイデータ使用量",
        "menu_65": "参照(データ使用量明細)",
        "menu_66": "データ使用量購入",
        "menu_67": "マイ容量",
        "menu_68": "マイデバイス",
        "menu_69": "注文明細",
        "menu_70": "参照(チャージ)",
        "menu_71": "参照(購入済みテンプレート)",
        "menu_72": "参照(購入済みデータ使用量)",
        "menu_73": "その他の権限",
        "menu_74": "参照(マテリアル・プログラム統計)",
        "menu_75": "参照(資産)",
        "menu_76": "参照(クラウドデータ使用量/統計)",
        "menu_77": "参照(デバイスオンライン統計)"
    },
    login: {
        terminalServiceSystem: 'スマートターミナルサービスシステム',
        accountLogin: 'アカウントログイン',
        register: '登録',
        accountLoginTip: '既存アカウントでログイン',
        scanQRCode: 'QRコードをスキャンしてください',
        readAndAgree: '利用規約に同意します',
        readAndAgreeLink: 'ユーザーサービス契約',
        readAndAgreeAgreement: 'ユーザーサービス契約に同意してください',
        forgetpassword: "パスワードを忘れましたか？",
        resetpassword: "パスワードのリセット",
        phoneEmptyTip: "携帯番号を入力してください",
        nextStep: "次のステップ",
        title: 'ログインをお待ちしております',
        submit: 'ログイン',
        userName: 'アカウント',
        password: 'パスワード',
        userNameEmptyTip: 'アカウントを入力してください',
        passwordEmptyTip: 'パスワードを入力してください',
        passwordFormatTip: '正しいパスワード形式を入力してください',
        passwordIsOk: '確認用パスワードを入力してください',
        passwordSign: 'パスワードを入力してください',
        codeTip: "認証コードを入力してください",
        phone: "携帯番号は必須です",
        code: "認証コードは必須です",
        nickname: "会社名は必須です",
        pass: "パスワードは必須です",
        pwdMessage: "パスワードは8～20文字で、スペースを含めず、大文字・小文字・数字・特殊文字のうち3種類以上を含む必要があります",
        pwdMessage01: "パスワードは英字と数字の組み合わせで8文字以上を入力してください",
        pwdMessage02: "パスワードは8～20文字です",
        pwdMessage03: "パスワードにスペースを含めることはできません",
        pwdMessage04: "パスワードには大文字・小文字・数字・記号のうち3種類以上を含む必要があります",
        newpassempty: "新しいパスワードは必須です",
        newpass: "2回入力したパスワードが一致しません",
        getcode: "認証コードを取得",
        format: "携帯番号の形式が正しくありません",
        chongfa: "秒後に再送信",
        isSend: '送信済み',
        noregister: "アカウントがありませんか？すぐに登録",
        Mobile: "携帯番号",
        verificationcode: "認証コード",
        petname: "ニックネーム",
        Quickregistration: "クイック登録",
        xiugaimima: "パスワードの変更",
        jiumima: "古いパスワード",
        xinmima: "新しいパスワード",
        zaicishuruxinmima: "新しいパスワードを再入力",
        xiugaichenggong: "変更に成功しました",
        xiugaishoujihao: "携帯番号の変更",
        dengluzhanghao: "ログインアカウント",
        gongsiid: "会社ID",
        yonghunicheng: "ユーザーニックネーム",
        chuangjianshijian: "作成時間",
        gongsimingcheng: "会社名",
        denglumima: "ログインパスワード",
        jianyi: "英字と数字の組み合わせのパスワードを使用することを推奨します",
        shezhimima: "パスワードの設定",
        shezhishoujihao: "携帯番号の変更/設定",
        yibangding: "バインド済み",
        weibangding: "未バインド",
        zhanghuanquan: "アカウントセキュリティ",
        yonghuxinxi: "ユーザー情報",
        zhuceSucMsg: 'おめでとうございます、登録に成功しました!',
        verificationcodeSucMsg: "認証コードの送信に成功しました！",
        requiredIsEmpty: "必須項目は空にできません！",
        emailObj: {
            title: 'メールアドレス',
            tit: 'メールログイン',
            tip: 'メールアドレスを入力してください',
            formatTip: '正しいメール形式を入力してください',
        },
        phoneObj: {
            title: '携帯番号',
            tit: '携帯ログイン',
            tip: '携帯番号を入力してください',
            formatTip: '正しい携帯番号形式を入力してください',
        },
        emailOrPhoneObj: {
            title: 'メールまたは携帯番号',
            tit: 'メールまたは携帯番号でログイン',
            tip: 'メールまたは携帯番号を入力してください',
            formatTip: '正しいメールまたは携帯番号形式を入力してください',
        },
        wechatObj: {
            title: 'WeChat',
            tit: 'WeChatログイン',
        },
        googleObj: {
            title: 'Google',
            tit: 'Googleログイン',
        },
        confirm: '確定',
        confirmSubmit: '提出を確定',
        cancel: 'キャンセル',
        close: '閉じる',
        bindSucMsg: 'バインドに成功しました',
        toContinueBindAccount: '第三者アカウントのバインドを完了するために続行',
        bindTip01: 'アカウントがありませんか？登録する',
        bindTip02: '既存アカウントがある',
        bindTip03: '現在の第三者アカウントはプラットフォームアカウントにバインドされていません。既存アカウントをバインドするか、新規アカウントを登録してバインドしてください。次回はクイックログインが可能です。',
        bindTip04: '既存アカウントをバインド',
        bindTip05: '新規アカウントを登録してバインド',
        bindTip06: '第三者からの認証を完了しました。以下のログイン情報を補完するとバインドが完了します',
        bindSubmit: 'バインドを提出',
        enterAccountTip: 'アカウント名を入力してください',
        RegisterAndBind: '登録してバインド',
        loginErr: 'ユーザー名またはパスワードが間違っています！',
        usercenter: "ユーザーセンター",
        pleaseInputName: "名前を入力してください",
        operationSuccess: "操作に成功しました！",
        edit: "編集",
        xiugai: "修正",
        userData: "個人データ",
        changePassword: "パスワードの変更",
        account: "アカウント",
        userName01: "ユーザー名",
        phoneNumber: "携帯番号",
        role: "ロール",
        createTime: "作成時間",
        genghuang: "交換",
        bangding: "バインド",
        unbind: "バインド解除",
        plesaseSelectBindingType: "バインドタイプを選択してください",
        pleaseConfirmCont: "この内容を読んだことを確認してください",
        confirmReadCont: "この内容を読みました",
        frequentTip: "操作が頻繁すぎます、後で再取得してください!",
        zhuxiaoBtn: "アカウントの注消",
        zhuxiaoTitle: "アカウント注消",
        querenZhuxiao: "注消を確定",
        jiXu: "続行",
        sendCodeBtn: "認証コードを送信",
        passwordIsNotOldPassword: "確認用パスワードと新しいパスワードが異なります",
        passwordIsOldPassword: "変更後のパスワードが元のパスワードと同じです",
        passFormatError: "正しいパスワード形式を入力してください",
        oldPassWord: "元のパスワード",
        newPassWord: "新しいパスワード",
        inputPlaceholder: '入力してください',
        confirmPassword: "確認用パスワード",
        zhuxiaoTip: `
            1、アカウントの注消は回復不能な操作です。一旦注消すると、このアカウントまたはこのアカウントで登録・ログインした第三者アカウントでログインおよび使用することができなくなります。アカウント関連の情報とデータは事前にバックアップしてください。
            2、このアカウントを登録する前に、すべての資産を空にし、紛争がないことを必ず確認してください。このアカウントが注消されると、アカウント内のすべての資産および権益の所有権を放棄したものとみなされ、回復または取り戻すことはできません。
            3、同一携帯番号で登録したアカウントの注消回数が合計3回に達した場合、該当携帯番号で新規アカウントを登録することができなくなり、同時に他のいかなるアカウントにもバインドすることができなくなります。
            `
    },
    home: {
        title: "ホーム",
        quickOperation: "クイック操作",
        addDevice: "デバイスの追加",
        publishProgram: "番組の発布",
        publishMaterial: "素材の発布",
        makeProgram: "番組の制作",
        uploadMaterial: "素材のアップロード",
        todayData: "本日のデータ（毎時間更新）",
        playNumChart: "再生回数統計",
        deviceOnlineStatus: "デバイスオンライン状況",
        onLineDevice: "オンラインデバイス",
        unLineDevice: "オフラインデバイス",
        programPlayTime: "番組再生時間統計",
        downloadSoft: "ソフトウェアのダウンロード",
        adminApp: "モバイルユーザー端末",
        playerApp: "情報発布再生端末",
        downloadAdminApp: "ユーザー端末をダウンロードする",
        downloadPlayerApp: "再生端末をダウンロードする",
        aboutUs: "会社概要",
        userManual: "ユーザーマニュアル",
        message: "お問い合わせ",
    },
    device: {
        inputPlaceholder: '入力してください',
        selectPlaceholder: '選択してください',
        osTypeStr: 'ターミナルシステム',
        onLineStatus: 'オンライン状態',
        dpi: '解像度',
        companyDeptIdName: '所属機関',
        deviceGroupIdName: '所属グループ',
        editOrMove: '編集/移動',
        loanOriginationFee: 'ローン手数料',
        strategyInfoLook: '戦略情報の確認',
        programLook: '番組の確認',
        addEquipments: 'デバイスの追加',
        luminanceSet: '輝度制御',
        terminal: 'ターミナル設定',
        transferCompany: '部署の移管',
        releasedProgram: '番組の発布',
        screenshot: 'スクリーンショット',
        changeGroup: 'グループの変更',
        defaultGroup: "デフォルトグループ",
        operation: "操作",
        edit: "編集",
        saveEdit: "編集を保存",
        add: "追加",
        save: "保存",
        setting: "設定",
        program: "番組",
        unbind: "バインド解除",
        sleep: "スリープ",
        wakeup: "起動",
        restart: "再起動",
        shutdown: "シャットダウン",
        reportLog: "ログの報告",
        clearPlayData: "再生端末データのクリア",
        offlineWarn: "該当デバイスはオフラインです、デバイスがオンラインになったら再試行してください！",
        confirmUnbind: "バインド解除を確定",
        confirmReset: "クリアを確定",
        confirmDelete: "削除を確定",
        delete: "削除",
        cancelDelete: "削除のキャンセル",
        confirmResetSuccess: "クリアに成功しました",
        confirm: "確定",
        cancel: "キャンセル",
        operationSuccess: "操作に成功しました",
        unbindSuccess: "バインド解除に成功しました",
        pleaseSelectDevice: "デバイスを選択してください",
        pleaseSelectOnlineDevice: "オンラインデバイスを選択してください",
        confirmMixOperation: "選択したデバイスにはオフラインデバイスが含まれています、該当設定はオフラインデバイスには有効ではありません、操作を続行することを確認しますか？",
        pleaseSelectDate: "日付を選択してください",
        reportSuccess: "報告に成功しました",
        deviceSetting: "デバイス設定",
        default: "デフォルト",
        all: "すべて",
        deviceList: "デバイスリスト",
        addDevice: "デバイスの追加",
        department: "部署機関",
        deviceType: "解像度",
        osType: "ターミナルシステム",
        onlineState: "オンライン状態",
        online: "オンライン",
        offline: "オフライン",
        notActive: "未アクティブ",
        search: "キーワードを入力してください",
        batchOperation: "一括操作",
        allDevices: "すべてのデバイス",
        deviceAttribute: "デバイス属性",
        selectReportDate: "報告日付を選択",
        inputName: "名前を入力してください",
        inputWidth: "幅を入力してください",
        inputHeight: "高さを入力してください",
        inputResolutionRatio: "0より大きい整数を入力してください！",
        inputSort: "ソートを入力してください",
        serialNum: "シリアル番号",
        name: "名前",
        width: "幅",
        height: "高さ",
        resolutionRatio: "解像度",
        inputResolutionRatioName: "解像度名を入力してください",
        sort: "ソート",
        personal: "個人",
        system: "システム",
        type: "タイプ",
        systemDefaultSettingUneditable: "システムデフォルト設定は編集不可!",
        systemDefaultSettingUnDeletable: "システムデフォルト設定は削除不可!",
        newz: "新規追加",
        total: "合計",
        totalNum: "件",
        strategyName: "戦略名",
        associatedTerminalNum: "関連ターミナル数",
        createTime: "作成時間",
        pleaseSelectStrategy: "戦略を選択してください！",
        onlySelectOneData: "データは1件だけ選択できます！",
        downloadStrategy: "戦略のダウンロード",
        inputStrategyName: "戦略名を入力してください",
        luminanceControl: "輝度制御",
        volumeStrategy: "音量戦略",
        saveSuccess: "保存に成功しました",
        screenAngle: "画面回転(°)",
        startTime: "開始時間",
        endTime: "終了時間",
        repeat: "リピート",
        monday: "月曜日",
        tuesday: "火曜日",
        wednesday: "水曜日",
        thursday: "木曜日",
        friday: "金曜日",
        saturday: "土曜日",
        sunday: "日曜日",
        everyday: "毎日",
        downloadSpeed: "ダウンロード速度",
        inputDownloadSpeed: "ダウンロード速度を入力してください",
        operator: "操作",
        pleaseSelectDeleteData: "削除するデータを選択してください！",
        confirmBatchDelete: "一括削除を確認しますか？",
        pleaseInputName: "名前を入力してください",
        detailSetting: "詳細設定",
        weekPlan: "週計画",
        specialDateSetting: "特別日設定",
        weekdayInfo: "曜日は必須項目です!",
        volumeInfo: "音量は必須項目です!",
        timeError: "時間選択エラー!",
        editSuccess: "編集操作に成功しました！",
        addSuccess: "追加操作に成功しました！",
        addSpecialPlan: "特別戦略計画の追加",
        downloadSpeedInfo: "ダウンロード速度:(0はダウンロード禁止を表す)",
        pleaseSelectStartTime: "開始時間を選択してください",
        pleaseSelectEndTime: "終了時間を選択してください",
        luminanceError: "正しい輝度値を入力してください！",
        defaultLuminance: "デフォルト輝度",
        luminance: "輝度値",
        defaultLuminanceInfo: "デフォルト輝度(100は最も明るい、0は最も暗い)",
        volume: "音量",
        saveLuminance: "輝度を保存",
        changeSuccess: "変更に成功しました！",
        changeNetwork: "ネットワークの変更",
        netName: "ネットワーク名",
        nameempty: "ネットワーク名は必須です",
        currentNetwork: "現在のネットワーク",
        ipAddress: "IPアドレス",
        dailyMode: "毎日モード",
        weeklyMode: "毎週モード",
        turnOnTime: "電源オン時間",
        turnOffTime: "電源オフ時間",
        startSleep: "スリープ開始",
        endSleep: "スリープ終了",
        batchDelInfo: "選択した項目を削除することを確定しますか？",
        timeCannotBeEmpty: "時間は空にできません!",
        startUp: "電源オン",
        shutDown: "電源オフ",
        volumeSize: "音量値",
        defaultVolume: "デフォルト音量(100は最大、0はミュート)",
        chooseStartTime: "開始時間を選択してください",
        chooseEndTime: "終了時間を選択してください",
        saveVolume: "音量を保存",
        screenRotationUnSaved: "画面回転が保存されていません",
        volumeSettingUnSaved: "音量設定が保存されていません",
        luminanceSettingUnSaved: "輝度設定が保存されていません",
        confirmClosePopup: "このポップアップを閉じることを確認しますか?",
        volumeSettingSuccess: "音量の変更に成功しました",
        luminanceSettingSuccess: "輝度の変更に成功しました",
        advancedSettingUnSaved: "詳細設定が保存されていません",
        settingTitle: "ターミナル設定",
        volumeSetting: "音量設定",
        luminanceSetting: "輝度設定",
        downloadSetting: "ダウンロード設定",
        sleepSetting: "スリープ設定",
        onOffSetting: "タイマー電源オン/オフ",
        screenRotation: "画面回転",
        namingError: "命名エラー、ファイル名にスペースを含めることはできません！",
        deleteSuccess: "削除に成功しました",
        deleteFolder: "フォルダの削除",
        pleaseInputDeviceName: "デバイス名を入力してください",
        pleaseInputDeviceId: "デバイスIDを入力してください",
        discoverDevice: "デバイスの発見",
        deviceId: "デバイスID",
        bound: "バインド済み",
        bind: "バインド",
        noDevice: "デバイスはありません",
        refresh: "リフレッシュ",
        manualAdd: "手動追加",
        deviceGroup: "デバイス分類",
        pleaseSelectGroup: "グループを選択してください！",
        deviceName: "デバイス名",
        goAdd: "追加ページへ",
        close: "閉じる",
        bindCountInsufficient: "バインド可能数が不足しています、デバイス数をアップグレードしてから追加してください！",
        displayNumber: "表示番号",
        groupName: "グループ名",
        pleaseSelectGroupName: "グループ名を記入してください！",
        moveGroup: "グループの移動",
        longitude: "経度",
        latitude: "緯度",
        nationality: "国籍",
        province: "都道府県",
        city: "市区町村",
        county: "郡",
        outNetIp: "外部ネットワークIP",
        inNetIp: "内部ネットワークIP",
        companyName: "企業名",
        Info: "詳細",
        android: "Android",
        win: "Windows",
        osVersion: "システムバージョン",
        softwareVersion: "ソフトウェアバージョン",
        diskSize: "ディスク容量",
        useSize: "使用済み容量",
        macAddr: "MACアドレス",
        longitudeLatitudeInfo: "経度と緯度は同時に空または空でない必要があります!",
        terminalName: "ターミナル名",
        terminalGroup: "ターミナルグループ",
        reportJournal: "報告するかどうか",
        systemVersion: "システムバージョン",
        storageSpace: "ストレージ容量",
        resolution: "解像度",
        runningMemory: "実行メモリ",
        model: "モデル",
        registerStatus: "登録状態",
        password: "パスワード",
        passwordInfo: "6～18桁の単語または数字を入力してください!",
        group: "グループ",
        address: "住所",
        remark: "備考",
        renewalPeriod: "更新期間",
        money: "料金",
        latitudeInfo: "正しい緯度を入力してください!",
        totalPayment: "総金額",
        longitudeInfo: "正しい経度を入力してください!",
        setMeal: "プラン",
        number: "数量",
        programName: "番組名",
        playStatus: "再生状態",
        playType: "再生方式",
        play: "再生",
        pause: "一時停止",
        playTime: "再生時間",
        programDeleted: "番組は既に削除されました",
        playSuccess: "番組の再生スケジュールが完了しました",
        pauseSuccess: "一時停止に成功しました",
        playCycle: "ループ再生",
        playInsert: "挿入再生",
        withdrawSuccess: "撤回に成功しました",
        withdrawInfo: "まず撤回する番組を選択してください！",
        programBelong: "所属番組",
        checkAll: "全選択",
        batchDel: "一括削除",
        delConfirm: "選択した項目を削除することを確定しますか？",
        check: "選択",
        noProgram: "番組はありません",
        details: "詳細",
        screenshotFail: "スクリーンショットに失敗しました",
        policyName: "ポリシー名",
        terminalNum: "関連ターミナル数",
        powerStrategy: "電源戦略",
        pleaseSelectDepartment: "部署を選択してください！",
        screenshotControl: "スクリーンショット制御",
        未激活: "未アクティブ",
        已激活: "アクティブ済み",
        未绑定: "未バインド",
        已绑定: "バインド済み",
    },
    programManage: {
        programList: "番組リスト",
        publishProgram: "番組発布追跡",
        week1: "月曜日",
        week2: "火曜日",
        week3: "水曜日",
        week4: "木曜日",
        week5: "金曜日",
        week6: "土曜日",
        week7: "日曜日",
        monday: "月曜日",
        tuesday: "火曜日",
        wednesday: "水曜日",
        thursday: "木曜日",
        friday: "金曜日",
        saturday: "土曜日",
        sunday: "日曜日",
        name: "名前",
        preview: "プレビュー",
        playDeviceNum: "再生デバイス数",
        copyDeviceCode: "コピーする",
        osType: "システムタイプ",
        playDate: "再生日付",
        playWeek: "再生週",
        everyday: "毎日",
        start: "開始",
        end: "終了",
        playOperateStatusStr: "発布状態",
        playDevice: "再生デバイス",
        downloadView: "ダウンロード確認",
        publisher: "発布者",
        publishTime: "発布時間",
        operation: "操作",
        add: "追加",
        groupName: "グループ名",
        selectDevice: "ターミナルの選択",
        searchDevice: "ターミナルの検索",
        pleaseFillGroupName: "グループ名を記入してください！",
        remarkInfo: "備考",
        compile: "編集",
        withdrawConfirm: "該当番組を撤回することを確認しますか？",
        confirm: "確定",
        cancel: "キャンセル",
        withdraw: "撤回",
        batchWithdraw: "一括撤回",
        batchPublish: "一括発布",
        batchDelete: "一括削除",
        batchOperation: "一括操作",
        notUse: "未使用",
        notChecked: "未審査",
        notPass: "不通过",
        delete: "削除",
        publishTextLeft: "発布済み",
        offTextLeft: "一時停止済み",
        pleaseSelectProgramToMove: "移管する番組を選択してください！",
        pause: "一時停止",
        pauseConfirm: "一時停止することを確定しますか？",
        play: "再生",
        downloadUdisk: "USBメモリへダウンロード",
        deviceList: "デバイスリスト",
        groupSelection: "グループ選択",
        operationSuccess: "操作に成功しました",
        deleteSuccess: "削除に成功しました",
        selectDate: "日付の選択",
        publishStatus: "発布状態",
        checkStatus: "審査状態",
        waitAuditing: "審査待ち",
        auditPass: "審査通過",
        auditRefuse: "審査拒否",
        all: "すべて",
        playStatus: "再生中",
        playStatust: "再生状態",
        pauseStatus: "一時停止済み",
        notStartStatus: "未開始",
        resolutionratio: "解像度",
        totalNum: "件",
        programName: "番組名",
        playStartTime: "再生開始時間",
        playEndTime: "再生終了時間",
        createTime: "作成時間",
        nationality: "国籍",
        province: "都道府県",
        city: "市区町村",
        county: "郡",
        address: "住所",
        ip: "IPアドレス",
        location: "位置",
        log: "ログ",
        pleaseFillProgramName: "番組名を記入してください！",
        selectGroup: "グループの選択",
        startTime: "開始時間",
        endTime: "終了時間",
        publishCycle: "発布周期",
        publishDeviceNum: "発布デバイス数",
        pleaseSelectRecord: "レコードを選択してください",
        deviceName: "ターミナル名",
        deviceId: "ターミナルデバイスID",
        deviceGroupIdName: "所属グループ",
        notClassified: "未分類",
        osTypeStr: "ターミナルシステム",
        storageSpace: "ストレージ容量",
        onLineStatus: "オンライン状態",
        onLine: "オンライン",
        offLine: "オフライン",
        sleep: "スリープ",
        unknown: "不明",
        registerStatus: "登録状態",
        trialPeriod: "試用期間",
        notActive: "未アクティブ",
        active: "アクティブ済み",
        parameterError: "パラメータが正しくありません!",
        pleaseSelectProgram: "番組を選択してください!",
        pleaseSelectProgramEdit: "編集する番組を選択してください!",
        confirmWithdrawSelectedProgram: "選択した番組を撤回することを確認しますか？",
        withdrawSuccess: "撤回に成功しました",
        allPrograms: "すべての番組",
        defaultGroup: "デフォルトグループ",
        cannotShareEmptyProgram: "空の番組を共有することはできません！",
        onlyShareYourProgram: "自分で作成した番組だけを共有できます!",
        pleaseSelectProgramEditPublishTime: "発布時間を編集した番組を選択してください!",
        pleaseSelectDevice: "デバイスを選択してください!",
        programDetail: "番組詳細",
        errorReason: "エラー原因",
        availableStorageSpaceInsufficient: "使用可能なストレージ容量が不足しています",
        partialDeviceReleaseFailure: "一部のデバイスの発布に失敗しました",
        allDeviceReleaseSuccess: "すべてのデバイスの発布に成功しました",
        partialDeviceReleaseSuccess: "一部のデバイスの発布に成功しました",
        allGroup: "すべてのグループ",
        allProgram: "すべての番組",
        unGrouped: "未グループ化",
        replaceProgram: "番組の置換",
        replaceProgramTip: "新しく発布した番組は再生端末に既に配布された番組データを置換します！",
        screen: "シングル/デュアルスクリーン",
        singleScreen: "シングルスクリーン",
        doubleScreen: "デュアルスクリーン",
        playSetting: "再生設定",
        batchPlaySetting: "再生時間の一括設定",
        individualPlaySetting: "再生時間の個別設定",
        playTime: "再生時間",
        daily: "毎日",
        weekdays: "月曜日～金曜日",
        monthly: "当月",
        advancedSetting: "詳細設定",
        playProgram: "番組の再生",
        searchProgram: "キーワードを入力してください",
        shareAddressNotExist: "リンクアドレスが存在しません、再試行してください",
        copySuccess: "コピーに成功しました",
        shareLink: "共有リンク",
        publish: "発布",
        noResource: "リソースはありません",
        single: "シングルスクリーン",
        double: "デュアルスクリーン",
        time: "時間",
        associatedTerminalNum: "関連ターミナル数",
        default: "デフォルト",
        moveGroup: "グループの移動",
        pleaseSelectGroup: "グループ名を記入してください！",
        copy: "コピー",
        FUBEN: "コピー",
        nameempty: "名前は必須です",
        whitespace: "命名エラー、ファイル名にスペースを含めることはできません！",
        programWhitespace: "命名エラー、番組名にスペースを含めることはできません！",
        pleaseSelectResolution: "解像度を選択してください！",
        dataError: "データが正しくありません！",
        createProgram: "新規番組作成",
        directCreate: "直接作成",
        myTemplate: "マイテンプレート",
        use: "使用",
        free: "無料",
        loadMore: "もっと読み込む",
        confirmDelete: "削除を確認",
        deleteGroup: "グループの削除",
        notPublished: "未発布",
        notPassed: "不通过",
        notUsed: "未使用",
        confirmDeleteSelectedProgram: "選択した番組を削除することを確認しますか？",
        companyName: "企業名",
        programCannotDownload: "該当番組はダウンロード不可！",
        publishMaterial: "素材の発布",
        playMaterial: "素材の再生",
        pleaseInputMaterialName: "素材名を入力してください",
        size: "サイズ",
        pleaseInputDeviceName: "デバイス名を入力してください",
        item: "件",
        allMaterial: "すべての素材",
        allDevices: "すべてのデバイス",
        "saveSuccess": "保存に成功しました",
        "savefaill": "保存に失敗しました",
        "playMode": "再生モード",
        "cyclePlay": "ループ再生",
        "insertPlay": "挿入再生",
        "noData": "データがありません",
        "Add": "新規追加",
        "replace": "置き換え",
        "repeat": "繰り返し",
        "start01": "開始",
        "end01": "終了",
        "startDate": "開始日",
        "endDate": "終了日",
        "useNow": "すぐに使用",
        "fillStartEndTimeFirst": "追加する前に開始時間と終了時間を記入してください",
        "fillFullPlayTime": "完全な再生時間を記入してください",
        "fillCorrectPlayTime": "正しい再生時間帯を記入してください",
        "sDateAndEDateBothEmptyOrFilled": "開始日と終了日は両方空欄にするか、両方記入する必要があります"
    },
    source: {
        addResource: "リソースの追加",
        width: "幅",
        height: "高さ",
        size: "サイズ(KB)",
        name: "名前",
        pleaseInputResourceName: "リソース名を入力してください！",
        addToGroup: "グループに追加",
        remark: "備考",
        promptFgIllustrate: "イラスト",
        promptFgRealisticPhoto: "リアルフォト",
        promptFgSimplisticDrawing: "簡単な描画",
        promptFgChineseStyle: "中国風",
        promptFgPixelArt: "ピクセル風",
        noModel: "モデルはありません、管理者にお問い合わせください！",
        getModelFailed: "モデルの取得に失敗しました、後で再試行してください！または管理者にお問い合わせください！",
        createImagePrompt: "画像生成中、後で閉じてください！",
        promptEmpty: "プロンプトワードを入力してください",
        dpiEmpty: "画像比率を選択してください！",
        fgEmpty: "スタイルを選択してください！",
        style: "スタイル",
        idEmpty: "画像IDは必須です",
        exist: "該当画像は既に素材に存在します",
        addSuccess: "素材の追加に成功しました",
        saveError: "画像の保存に失敗しました、後で再試行してください！",
        delSuccess: "削除に成功しました",
        generateImage: "テキストから画像生成",
        generateImagePlaceholder: '生成したい画像を入力してください、例：蝶が花畑で舞い踊っている',
        aiExpand: "スマート拡張",
        negativePrompt: "ネガティブプロンプト",
        negativePromptTooltip: "出力に表示したくない内容や特徴を明確に除外するために使用",
        imageRatio: "画像比率",
        generateImageBtn: "すぐに生成",
        shengchengjieguo: "生成結果",
        generateImageLoadingTip: "生成中、重複してクリックまたは閉じないでください...",
        Tooltip: "AIであなたの創造力を引き出そう",
        saveToMaterial: "素材に保存",
        publish: "すぐに発布",
        download: "ダウンロード",
        generateHistory: "生成履歴",
        hide: "収納",
        cancel: "キャンセル",
        useExpand: "拡張を使用",
        all: "すべて",
        delete: "削除",
        loadMore: "もっと読み込む",
        aiTip: "内容は人工知能モデルによって生成されたもので、プラットフォームの見解、立場または態度を代表するものではありません。AIコンテンツを合理的かつ適合的に使用してください",
        operationSuccess: "操作に成功しました",
        moveGroup: "グループの移動",
        groupName: "グループ名",
        pleaseSelectGroup: "グループ名を選択してください！",
        shenhe: "審査",
        shenheStatus: "審査状態",
        shenheSuccess: "審査通過",
        shenheRefuse: "審査拒否",
        pleaseSelectShenheStatus: "審査状態を選択してください！",
        shenheRemark: "審査備考",
        pleaseInputShenheRemark: "審査備考を入力してください！",
        pleaseInputFileName: "ファイル名を入力してください！",
        whitespace: "命名エラー、ファイル名にスペースを含めることはできません！",
        dataError: "データが正しくありません！",
        confirmDelete: "削除を確認",
        confirm: "確定",
        deleteFolder: "フォルダの削除",
        add: "追加",
        edit: "編集",
        fileName: "ファイル名",
        group: "グループ",
        resolution: "解像度",
        type: "タイプ",
        image: "画像",
        music: "音楽",
        video: "動画",
        uploadTime: "アップロード時間",
        uploadUser: "アップロード者",
        checkTime: "審査時間",
        checkUser: "審査者",
    },
    setting: {
        nameempty: "名前は必須です",
        heightempty: "高さは必須です",
        widthempty: "幅は必須です",
        resolutionratio: "解像度",
        name: "名前",
        opteration: "操作",
        compile: "編集",
        delete: "削除",
        newz: "新規追加",
        compileratio: "解像度の編集",
        sheizhifenbianlvmingcheng: "解像度名の設定",
        shezhigaodu: "高さの設定",
        shezhikuandu: "幅の設定",
        xinzengfenbianlv: "解像度の新規追加",
        bianma: "エンコード",
        bianjizhongduanmingcheng: "ターミナル名の編集",
        xinzengzhongduan: "ターミナルの新規追加",
        selectPrimaryColor: 'テーマカラーの選択',
        fullScreen: 'フルスクリーン',
        exitFullScreen: 'フルスクリーンを終了',
    },
    tabs: {
        refresh: 'リフレッシュ',
        refreshAll: 'すべてリフレッシュ',
        close: '閉じる',
        closeOthers: 'その他を閉じる',
        closeAll: 'すべて閉じる',
        closeLeft: '左側を閉じる',
        closeRight: '右側を閉じる',
    },
    errorPage: {
        needLogin: 'まだログインしていません！',
        pageNotFound: 'アクセスしたページが存在しません！',
        redirectTo: 'にリダイレクト',
        orReturn: 'または戻る',
        previousStep: '前のステップ',
    },
    headerUs: {
        systemNotice: "システム通知",
        allNotices: "すべての通知",
        viewAllMessages: "すべてのメッセージを確認",
        contactUs: "お問い合わせ",
        operationSuccess: "操作に成功しました！",
        leaveMessage: "お問い合わせ",
        messageTitle: "タイトル",
        messageTitleTip: "タイトルを入力してください！",
        messageContentTip: "150文字以内",
        submit: "提出",
        markAsRead: "既読にする",
        success: "操作に成功しました！"
    },
    material: {
        allMaterial: "すべての素材",
        defaultGroup: "デフォルトグループ",
        auditStatus: "審査状態",
        auditPassed: "審査通過",
        auditRejected: "審査拒否",
        pendingAudit: "審査待ち",
        all: "すべて",
        operateSuccess: "操作に成功しました！",
        pleaseSelectMaterial: "素材を選択してください！",
        moveGroup: "グループの移動",
        pleaseSelectGroup: "グループを選択してください！",
        batchPublish: "一括発布",
        batchRecall: "一括撤回",
        batchDelete: "一括削除",
        materialList: "素材リスト",
        uploadMaterial: "素材のアップロード",
        materialType: "素材タイプ",
        pleaseInputMaterialName: "素材名を入力してください",
        selectAll: "全選択",
        confirmDeleteSelectedMaterial: "選択した素材を削除することを確認しますか？",
        deleteSuccess: "削除に成功しました",
        delete: "削除",
        publish: "発布",
        recall: "撤回",
        confirmRecallSelectedMaterial: "選択した素材を撤回することを確認しますか？",
        pleaseSelectMaterialGroup: "素材グループを選択してください！",
        recallSuccess: "撤回に成功しました",
        publishSuccess: "発布に成功しました",
        batchOperate: "一括操作",
        item: "件",
        confirmDelete: "削除を確認しますか？",
        edit: "編集",
        confirmRecall: "撤回を確認しますか？",
        unaudited: "未審査",
        notPassed: "不通过",
        operate: "操作",
        resolution: "解像度",
        none: "なし",
        confirm: '確定',
        cancel: 'キャンセル',
        AICreation: "AI創作",
    },
    uploadFile: {
        operationSuccess: "操作に成功しました",
        uploadFile: "アップロード管理",
        uploadSuccess: "アップロードに成功しました",
        uploadCompleted: "アップロード完了",
        uploadFail: "アップロードに失敗しました",
        ConversionFailed: "変換に失敗しました！",
        loading: "読み込み中...",
        beQueuing: "キューイング中...",
        Uploading: "アップロード中...",
        ConversionIng: "変換中...",
        ConventionalResources: "通常リソース",
        DocumentResources: "ドキュメントリソース",
        complete: "完了",
        upload: "アップロード",
        fileSizeWraning01: "素材サイズが超えました",
        fileSizeWraning02: "修正して再アップロードしてください！",
        fileIsEmpty: "ファイルは空です",
        uploadFileTip: "サポートされていないファイル形式",
        unablePreview: "素材ライブラリに正常に追加されていません、プレビュー不可",
        confirmDelete: "削除を確認しますか？",
        deleteSuccess: "削除に成功しました",
        delete: "削除",
        confirm: "確定",
        preview: "プレビュー",
        close: "閉じる",
        cancel: "キャンセル",
        fileType: "ファイルタイプ",
        fileSize: "ファイルサイズ",
        conversionProgress: "変換進捗",
        progress: "進捗",
        image: "画像",
        video: "動画",
        audio: "音楽",
        limitTip01: "一度にアップロード",
        limitTip02: "個のファイル",
        okTip: "素材をアップロード中、後で閉じてください！",
        usableSize: '使用可能容量',
        sizeUnableTip: "現在の使用可能なストレージ容量が不足しています、不要な素材をタイムリーにクリーンアップしてスペースを節約するか、ディーラーに連絡して容量を拡張してください。",
        view: "詳細を確認",
        fileName: "ファイル名",
    },
    template: {
        inputPlaceholder: '入力してください',
        selectPlaceholder: '選択してください',
        noAuths: "権限はありません、管理者にお問い合わせください",
        operationSuccess: "操作に成功しました",
        total: "合計",
        totalNum: "件",
        dan: "シングル",
        shaung: "ダブル",
        pleaseSelectGroup: "グループを選択してください",
        preview: "プレビュー",
        free: "無料",
        use: "使用",
        dpi: '解像度',
        delete: "削除",
        confirmDelete: "削除を確認",
        confirmDeleteSelectedTemplate: "このテンプレートを削除することを確認しますか",
        push: "発布",
        pushConfirm: "パブリックテンプレートに発布することを確認しますか",
        pushRemovalConfirm: "パブリックテンプレートから下架することを確認しますか",
        templateOrderRecord: "テンプレート注文記録",
        unpublished: "未発布",
        auditing: "審査中",
        publishRejected: "発布拒否",
        publishSuccess: "発布に成功しました",
        offShelf: "下架",
        公共模版: "パブリックテンプレート",
        我的模板: "マイテンプレート",
        共享记录: "共有記録",
        name: "名前",
        pubdate: "発布時間",
        keySeachTip: "キーワードを入力してください",
        allGroup: "すべてのグループ",
        add: "追加",
        edit: "編集",
        programName: "番組名",
        selectGroup: "グループの選択",
    },
    checkManage: {
        total: "合計",
        totalNum: "件",
        operationSuccess: "操作に成功しました",
        checkUserLogs: "審査記録（オペレーター）",
        checkLogs: "審査記録（審査員）",
        sourceCheck: "素材審査",
        programCheck: "番組審査",
        checkAll: "全選択",
        auditPass: "審査通過",
        auditRefuse: "審査拒否",
        auditPass01: "通過",
        auditRefuse01: "拒否",
        auditRefuse02: "審査を拒否",
        auditor: "審査者",
        agentUserName: "発布者",
        interrogationTime: "審査提出時間",
        checkTime: "審査時間",
        checkName: "審査名",
        checkType: "審査カテゴリ",
        checkIp: "審査提出IPアドレス",
        checkReason: "コメント",
        checkStatus: "操作内容",
        rangePicker: "審査日付",
        keyWord: "キーワード",
        all: "すべて",
        program: '番組',
        material: '素材',
        dan: "シングル",
        shaung: "ダブル",
        pleaseSelectProgram: "番組を選択してください!",
        pleaseSelectMaterial: "素材を選択してください！",
        preview: "プレビュー",
        dpi: '解像度',
        auditRefuseTip: "拒否理由を入力してください",
        unreviewed: "未審査",
        notPassed: "不通过",
        notUsed: "未使用",
        edit: "編集",
        none: "なし",
        name: "名前",
        size: "サイズ",
        type: "タイプ",
        uploadTime: "アップロード時間",
        uploadUser: "アップロード者",
        checkUser: "審査者",
        image: "画像",
        music: "音楽",
        video: "動画",
    },
    "systemSet": {
        total: "合計",
        "totalNum": "件",
        "inputPlaceholder": "入力してください",
        "selectPlaceholder": "選択してください",
        "userList": "組織メンバー",
        "roleList": "ロール権限",
        "department": "組織構成",
        "diskInfo": "ストレージ容量",
        "approveSet": "コンテンツ承認",
        "logList": "ログ管理",
        "name": "氏名",
        "account": "アカウント",
        "userName": "ユーザー氏名",
        "phoneNumber": "電話番号",
        "role": "ロール",
        "createTime": "作成時間",
        "operation": "操作",
        "edit": "編集",
        "delete": "削除",
        "addNew": "新規追加",
        "add": "追加",
        "resetPassword": "パスワードリセット",
        "confirmDelete": "削除を確定",
        "departmentOrganization": "部署機関",
        "addNewUser": "ユーザー新規追加",
        "pleaseEnterUserName": "ユーザー氏名を入力してください",
        "confirmPasswordNotMatch": "確認用パスワードが不一致です！",
        "operationSuccess": "操作成功！",
        "userNickname": "ユーザー名",
        "pleaseEnterUserNickname": "ユーザー名を入力してください",
        "userNicknameRequired": "ユーザー名は必須項目です！",
        "password": "パスワード",
        "pleaseEnterPassword": "パスワードを入力してください",
        "passwordRequired": "パスワードは必須項目です！",
        "passwordTip": "パスワードのセキュリティレベルが低すぎます（大小文字・数字・特殊文字のうち任意3種を含み、長さは8文字以上）",
        "confirmPassword": "パスワード確認",
        "pleaseEnterPhoneNumber": "電話番号を入力してください",
        "phoneNumberRequired": "電話番号は必須項目です！",
        "phoneNumberFormatError": "正しい電話番号を入力してください！",
        "roleRequired": "ロールは必須項目です！",
        "required": "必須項目です！",
        "departmentName": "部署",
        "modifyPassword": "パスワード変更",
        "newPassword": "新しいパスワード",
        "pleaseEnterNewPassword": "新しいパスワードを入力してください",
        "pwdMessage": "パスワードは8~20文字で、スペースを含めず、大小文字・数字・特殊文字のうち任意3種を含む必要があります",
        "all": "全て",
        "noAuths": "権限がありません。管理者にお問い合わせください",
        "departmentName01": "部署名",
        "image": "画像",
        "music": "音楽",
        "video": "動画",
        "buySize": "購入数量",
        "totalMoney": "支払金額",
        "buycreateTime": "購入時間",
        "endTime": "有効期限",
        "buyTypeStr": "注文タイプ",
        "sourceCheck": "素材審査",
        "programCheck": "プログラム審査",
        "programName": "プログラム名",
        "diskExpansion": "使用中に不要な素材をタイムリーに削除し、システムの利用可能容量を確保してください。より大きな容量が必要な場合は、機器販売元に連絡してクラウドストレージの拡張サービスを申し込めます。このサービスは有料となる場合がありますので、詳細は販売元の情報をご確認ください。",
        "selectPermission": "権限を選択してください",
        "checkPermission": "権限をチェックしてください",
        "addRole": "ロール追加",
        "enterRoleName": "ロール名を入力してください",
        "roleName": "ロール名",
        "roleNameRequired": "ロール名は必須項目です！",
        "remark": "備考",
        "enterRemark": "備考を入力してください",
        "permissionSetting": "権限設定",
        "deleteSuccess": "削除成功！",
        "confirmToDelete": "削除してもよろしいですか？",
        "orgName": "機関名",
        "orgNameRequired": "機関名は必須項目です！",
        "orgRemark": "機関備考",
        "enterOrgRemark": "機関備考を入力してください",
        "capacityUsage": "容量使用状況",
        "usedCapacity": "使用済容量",
        "totalCapacity": "総容量",
        "remainingCapacity": "残り容量",
        "capacityExpansion": "容量拡張",
        "enable": "有効",
        "disable": "無効",
        "userName01": "ユーザー名",
        "loginTime": "ログイン時間",
        "ipAddress": "IPアドレス",
        "loginResult": "ログイン結果",
        "selectDate": "日付選択",
        "enterDate": "日付を選択してください",
        "selectStartTime": "開始時間を選択してください",
        "selectEndTime": "終了時間を選択してください",
        "enterUserName": "ユーザー名を入力してください",
        "userCount": "ユーザー数",
        "roleDesc": "ロール説明",
        "roleAuthorization": "ロール権限付与",
        "success": "成功",
        "failure": "失敗",
        "time": "時間",
        "operationContent": "操作内容",
        "playCount": "再生回数",
        "playDuration": "再生時間",
        "selectDevice": "デバイス選択",
        "enterProgramName": "プログラム名を入力してください",
        "serialNumber": "シリアル番号",
        "publishContentName": "公開コンテンツ名",
        "playMode": "再生方式",
        "cyclePlay": "ループ再生",
        "insertPlay": "挿入再生",
        "paddingPlay": "補充再生",
        "playDeviceId": "再生デバイスID",
        "playDeviceName": "再生デバイス名",
        "publishTime": "公開時間",
        "downloadStatus": "ダウンロード状態",
        "notDownloaded": "未ダウンロード",
        "downloading": "ダウンロード中",
        "downloadSucceeded": "ダウンロード成功",
        "downloadFailed": "ダウンロード失敗",
        "enterPublishContentName": "公開コンテンツ名を入力してください",
        "terminalId": "端末ID",
        "belongOrg": "所属機関",
        "reportTime": "報告時間",
        "reportIp": "報告IP",
        "logInfo": "ログ情報",
        "details": "詳細",
        "confirmDeletion": "削除してもよろしいですか？",
        "logDetails": "ログ詳細",
        "download": "ダウンロード",
        "deptOrg": "部署機関",
        "query": "クエリ",
        "queryByTerminalId": "端末IDでクエリ",
        "batchDeleteLogs": "ログ一括削除",
        "customTimeDeleteLogs": "カスタム時間でログ削除",
        "selectTimeRangeFirst": "先に時間範囲を選択してください",
        "deleteAllDeviceLogsIfEmpty": "デバイスIDを入力しない場合、デフォルトで全デバイスのログを削除します",
        "enterDeviceIdToDeleteLogs": "削除対象のデバイスIDを入力してください",
        "confirmDeleteAction": "削除を確定",
        "selectDeleteRangeFirst": "先に削除範囲を選択してください",
        "networkConnectionFailed": "ネットワーク接続失敗",
        "playLog": "再生ログ",
        "publishLog": "公開ログ",
        "errorLog": "エラーログ",
        "operationLog": "操作ログ",
        "fileLog": "ファイルログ",
        "userOperateLog": "ログインログ"
    },
    "userManual": {
        "userManual": "ユーザーマニュアル",
        "noData": "データがありません"
    },
    "systemNotice": {
        "systemNotice": "システム通知",
        "noData": "データがありません",
        "total": "全",
        "totalNum": "件",
        "markAllRead": "全て既読にする",
        "deleteAll": "全て削除",
        "all": "全て",
        "unread": "未読",
        "read": "既読",
        "type": "タイプ",
        "content": "内容",
        "date": "日付",
        "status": "状態",
        "confirmDelete": "削除してもよろしいですか？",
        "confirm": "確定",
        "cancel": "キャンセル",
        "delete": "削除"
    }
};